import request from '../utils/request';
import { getLanguageUrl } from "@/utils/index";

/**
 * 判断当前用户能力诊断是否完成
 */
export function beforeShowSurvey(learningPathMetaId, type) {
    let url = `/sr/survey/getSurvey/${learningPathMetaId}/${type}`
    url = getLanguageUrl(url)
    return request.MainService({
        url: url,
        method: 'get',
        data: {}
    });
}

/**
 * 获取能力诊断或者能力考核情景描述内容
 */
export function abilityInfo(learningPathMetaId, type, reduceTime) {
    // let url = `/sr/survey/show/${learningPathMetaId}/${type}/${reduceTime}`
    let url = `/sr/survey/show/${learningPathMetaId}/${type}/0`
    url = getLanguageUrl(url)
    return request.MainService({
        url: url,
        method: 'get',
        params: {}
    });
}

/**
 * 重置题目
 */
export function resetTest(learningPathMetaId, type) {
    return request.MainService({
        url: `/sr/survey/reset/${learningPathMetaId}/${type}`,
        method: 'post',
        params: {}
    });
}


/**
 * 提交题目选项
 */
export function saveSurveyAnswer(params) {
    return request.MainService({
        url: '/sr/survey/saveSurveyAnswer',
        method: 'post',
        data: params
    });
}
/**
 * 完成本次测验
 */
export function finishSurvery(learningPathMetaId, type, submitType) {
    let url = `/sr/survey/finish/${learningPathMetaId}/${type}/${submitType}`
    url = getLanguageUrl(url)
    return request.MainService({
        url: url,
        method: 'post',
        data: {}
    });
}

/**
 * 获取能力诊断报告
 */
export function beforeTestRepoteNew(learningPathMetaId) {
    let url = `/sr/survey/beforeTestRepoteNew/${learningPathMetaId}`
    url = getLanguageUrl(url)
    return request.MainService({
        url: url,
        method: 'get',
        data: {}
    });
}

/**
 * 获取训练营前测报告
 */
export function campBeforeTestRepoteNew(learningPathMetaId) {
  let url = `sr/campSurvey/modulePreTestRepote/${learningPathMetaId}`
  url = getLanguageUrl(url)
  return request.MainService({
    url: url,
    method: 'get',
    data: {}
  });
}

/**
 * 获取能力考核报告
 */
export function afterTestRepoteNew(learningPathMetaId) {
    let url = `/sr/survey/afterTestReportNew/${learningPathMetaId}`
    url = getLanguageUrl(url)
    return request.MainService({
        url: url,
        method: 'get',
        data: {}
    });
}

/**
 * 获取综合考核报告
 */
export function unifyAfterTestReport(learningPathMetaId) {
  let url = `/sr/campSurvey/unifyAfterTestReport/${learningPathMetaId}`
  url = getLanguageUrl(url)
  return request.MainService({
    url: url,
    method: 'get',
    data: {}
  });
}







// WEBPACK FOOTER //
// ./src/api/ability.js